<template>
  <div>
    <div id="main-cid-detail" class="container cid-detail" style="background-color: white;">
      <menu-bar />
      <br />
      <br />
      <br />
      <div class="container-img" v-if="product.get('productCode') == 'CID'">
        <loading-grid class="loading-grid-img" v-show="isLoadImage" />
        <img :src="imageUrl" alt="Baner" @load="loaded()" />
      </div>

      <div class="row">
        <div class="col-md-6">
          <images-carousel v-if="product.get('images').length > 0" :Images="product.get('images')" />
        </div>
        <div class="col-md-6 container-detail">
          <div class="product-name">{{product.get('name')}}</div>
          <p class="viewer-count">จำนวนการดู {{product.get('viewerCounter') || 0}} ครั้ง</p>
          <p
            class="viewer-count"
            v-if="balanceStore"
            v-show="!isLoadBalanceStore"
          >จำนวนคงเหลือ {{!product.get('isSoldOut') ? balanceStore.balanceProduct || 0 : 0}} {{ product.get('productCode') == 'CID' ? 'เครื่อง' : product.get('unitType')}}</p>
          <loading-worm class="viewer-count" v-if="isLoadBalanceStore" size="small" />

          <br />

          <p class="price" v-if="product.get('price')" style="margin-bottom: 0;font-size:28px">
            <small
              v-if="product.get('fullPrice') && !product.get('subProducts')"
              style="font-size:16px;color: #858585;text-decoration: line-through;"
            >฿{{eArabic(product.get('fullPrice') , 2)}}</small>
            <small
              v-if="selectSubProduct && selectSubProduct.get('fullPrice')"
              style="font-size:16px;color: #858585;text-decoration: line-through;"
            >฿{{eArabic(selectSubProduct.get('fullPrice') , 2)}}</small>
            <br />
            <span v-if="product.get('subProducts')">
              <span
                v-if="!selectSubProductId"
              >ราคา {{ eArabic(Math.min(...product.get('subProducts').map(d => d.get('price')))) }} - {{ eArabic(Math.max(...product.get('subProducts').map(d => d.get('price')))) }} บาท</span>
              <span v-else-if="selectSubProduct">ราคา {{eArabic(selectSubProduct.get('price'))}} บาท</span>
            </span>
            <span v-else>ราคา {{eArabic(product.get('price'))}} บาท</span>
            <small
              style="font-size:16px;color: #858585;"
            >/{{product.get('productCode') == 'CID' ? 'เครื่อง' : product.get('unitType')}}</small>
          </p>
          <!-- <p v-if="selectSubProduct">
          ค่าส่ง {{eArabic(selectSubProduct.get('deliveryPerNumber'))}}
          </p>-->
          <!-- <small v-if="product.get('delivery') && product.get('delivery') > 0" style="padding-left:10px;">ค่าจัดส่ง {{product.get('delivery')}} บาท</small>
          <small v-else-if="product.get('price') && (!product.get('delivery') || product.get('delivery') == 0)" style="padding-left:10px;">ค่าจัดส่งฟรี <img src="../assets/icon/sendfree.png" alt="promo" width="30px" /> </small>-->

          <div class="box-detail" v-if="product.get('detail')">
            <h4>คุณสมบัติสินค้า</h4>
            <div class="html-detail" v-html="product.get('detail')"></div>
          </div>
          <!-- <div class="box-detail" v-if="product.get('description')">
          <h4>ข้อมูลสินค้า</h4>
          
          </div>-->

          <div
            class="box-number"
            style="margin-top:20px;border-top: 1px solid rgba(148, 148, 148, 0.5);"
          >
            <div class="row">
              <div class="col-md-12 py-2 text-left" v-if="product.get('subProducts')">
                ตัวเลือก :
                <template v-for="subProduct in product.get('subProducts')">
                  <div
                    :class="`select-sub-product ${selectSubProductId == subProduct.id ? 'active' : '' }`"
                    :key="subProduct.id"
                    @click="changeSubProduct(subProduct)"
                  >{{ subProduct.get('subProductName')}}</div>
                </template>
              </div>
              <div class="col-md-12 py-2">
                ระบุจำนวนสินค้า :
                <i
                  :class="`fas fa-minus ${formPurchase.number < 2 ? 'none':''}`"
                  @click="numberPluse('-')"
                ></i>
                <input
                  type="number"
                  name="number-order"
                  id="number-order"
                  v-model.number="formPurchase.number"
                  placeholder="จำนวน"
                  min="1"
                  max="9"
                  @keypress="isNumberPurchase()"
                  @input="changeNumber()"
                />
                <i
                  :class="`fas fa-plus ${balanceStore && formPurchase.number >= balanceStore.balanceProduct ? 'none':''}`"
                  @click="numberPluse('+')"
                ></i>
              </div>
              <div class="col-md-12" v-if="isErrorSelectSubProduct">
                <span class="text-danger">
                  <small>กรุณาเลือกตัวเลือกของสินค้าก่อน</small>
                </span>
              </div>
            </div>
          </div>
          <div class="box-btn-quotation" v-show="!isLoadInit">
            <div class="row pb-3">
              <div class="col-md-8 px-4 row">
                <div class="col-md-7 px-1">
                  <button
                    type="button"
                    :class="`btn-quotation w-100 w100-mobile ${product.get('isSoldOut') || isLoadBalanceStore || (balanceStore && balanceStore.balanceProduct <= 0) ? 'non-active':''}`"
                    @click="addToCart()"
                    style="margin: 0; padding: 8px 5px;"
                  >
                    <i class="fas fa-shopping-basket"></i> เพิ่มไปยังตะกร้า
                  </button>
                </div>
                <div class="col-md-5 px-1">
                  <button
                    type="button"
                    :class="`btn-main w-100 w100-mobile ${product.get('isSoldOut') || isLoadBalanceStore || (balanceStore && balanceStore.balanceProduct <= 0) ? 'non-active':''}`"
                    @click="requestQuotation()"
                    style="margin: 0; padding: 8px 5px;"
                  >ซื้อสินค้า</button>
                </div>
              </div>
            </div>
            <div style="border-top: 1px solid rgba(148, 148, 148, 0.5);"></div>
            <button
              type="button"
              :class="`btn-quotation`"
              @click="clickRegister()"
              v-if="product.get('productCode') == 'CID' && user"
            >{{registerData && registerData.isSuccess ? text.btnRegister : text.btnRegister2}}</button>
            <div
              class="text-last-purchase"
              v-if="lastPurchase && lastPurchase.get('orders') && lastPurchase.get('orders')[0].productId == product.id"
            >{{`ซื้อครั้งล่าสุด(${dateFormat(lastPurchase.get('purchaseDate'),'DD/MM/YY')}) ${lastPurchase.get('orders')[0].number} ชิ้น`}}</div>
            <!-- <div style="margin-top:10px;padding-left:30px;" class="text-left">
            <small class="text-danger">* กรุณาเข้าสู่ระบบและสั่งซื้อผ่าน <a href="https://app.horganice.in.th/login">www.horganice.in.th</a></small>
            </div>-->
          </div>
          <div class="box-btn-quotation" v-show="isLoadInit">
            <loading-cycle />
          </div>
        </div>
      </div>

      <div class="discription" v-if="product.get('description')">
        <div class="col-12" style="border-bottom: 1px solid rgba(148, 148, 148, 0.5);">
          <h3>
            <b>ข้อมูลสินค้า</b>
          </h3>
        </div>
        <div class="col-12">
          <div class="tab-content" id="nav-tabContent">
            <div
              class="tab-pane fade show active"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <div class="ql-snow">
                <div class="ql-editor">
                  <div v-html="product.get('description')"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <product-carousel :currentProduct="product.id"></product-carousel>

      <div id="modal-register" class="modal-register modal-register-hide">
        <div class="container container-register">
          <div class="header-register">
            <div
              class="text"
            >{{registerData && registerData.isSuccess ? text.btnRegister : text.btnRegister2}}</div>
            <div class="box-close" @click="toggleModalRegister">
              <i class="fas fa-times close-modal"></i>
            </div>
          </div>
          <div class="row register">
            <div class="col col-register col-md-12">
              <div class="sol-register">
                <img
                  v-if="!registerData || !registerData.isSuccess"
                  class="sol-image"
                  src="../assets/images/regist-card-reader.jpg"
                  alt="sol"
                />
              </div>

              <div class="box-border" style="padding:15px;">
                <h3 class="selecta-apartment-topic">เลือกหอพัก</h3>
                <p class="text-danger" v-if="!apartmentId">* กรุณาเลือกหอพัก</p>
                <span class="address-selector" v-if="allApartment && allApartment.length > 0">
                  <span v-for="(owner , index) of allApartment" :key="index">
                    <div
                      class="box-border text-left row"
                      :class="`${indexRegisterApartment == index ? 'active' : ''}`"
                      v-if="owner.get('apartment')"
                      @click="changeRegisterApartmnet(index , owner)"
                    >
                      <div style="width:50px;" class="text-center">
                        <div class="circle-out">
                          <div class="circle-in" v-if="indexRegisterApartment == index"></div>
                        </div>
                      </div>
                      <div>
                        <p class="topic-address">{{owner.get('apartment').get('name')}}</p>
                        <p class="detail-address">
                          {{owner.get('apartment').get('address') ? owner.get('apartment').get('address') : '-'}}
                          {{owner.get('apartment').get('addressZipcode')}}
                        </p>
                      </div>
                    </div>
                  </span>
                </span>
                <div v-else>
                  <h5 style="text-align: center;">--- ไม่มีหอพัก ---</h5>
                </div>

                <div class="box-loading" v-show="isLoadRegister">
                  <loading-cycle message="กำลังตรวจสอบ.." fontColor="gray" />
                </div>

                <div
                  class="box-register"
                  v-show="!isLoadRegister && allApartment && allApartment.length > 0 && apartmentId"
                >
                  <label class="label-register" for="input-register">Serial number(S/N) :</label>
                  <input
                    id="input-register"
                    class="input-register"
                    type="text"
                    placeholder="XXXXXXXXXXXXX (13 หลัก)"
                    @keypress="isNumber($event)"
                    v-model="inputRegister"
                  />
                  <div id="btn-register" class="btn-register" @click="checkRegister()">ลงทะเบียน</div>
                  <i
                    v-show="registerData  && !registerData.isNew && registerData.isSuccess"
                    class="far fa-check-circle"
                  ></i>
                  <i
                    v-show="registerData  && !registerData.isNew && !registerData.isSuccess"
                    class="far fa-times-circle"
                  ></i>
                </div>
              </div>

              <div
                class="box-registed"
                v-if="!isLoadRegister && registerData && registerData.isSuccess"
              >
                <div class="header-registed">
                  {{text.successRegister}}
                  <span
                    class="in"
                  >(หมายเลขซีเรียลที่ใช้ลงทะเบียน : {{registerData.data.get('serialNumber')}})</span>
                </div>
                <div
                  class="text-registed"
                  v-if="registerData && registerData.data && registerData.data.get('activatedDate')"
                >ลงทะเบียนวันที่ : {{dateFormat(registerData.data.get('activatedDate'),'DD MMM YYYY, HH:mm:ss')}}</div>
                <div class="file-registed">
                  <div class="text">
                    <a
                    target="_blank"
                      href="https://static.horganice.in.th/cid-reader/dist/Horganice%20CID%20Reader%20Setup%201.0.0.exe"
                      download
                    >
                      <img src="../assets/images/download-win.png" alt="Horganice Reader in Window" />
                    </a>
                    <a
                      target="_blank"
                      href="https://static.horganice.in.th/cid-reader/dist-mac/Horganice%20CID%20Reader-1.0.5.dmg"
                      download
                    >
                      <img src="../assets/images/download-mac.png" alt="Horganice Reader in MacOs" />
                    </a>
                    <a
                      target="_blank"
                      href="https://static.horganice.in.th/cid-reader/dist/คู่มือการใช้งาน-เครื่องอ่านบัตรประชาชน.pdf"
                      download
                    >
                      <img src="../assets/images/download-manual.png" alt="คู่มือการใช้งาน" />
                    </a>
                  </div>
                  <div
                    class="text-detail"
                  >รองรับระบบปฎิบัติการ Windows 7 ขึ้นไป ทั้งแบบ 32บิต, 64บิต และ MacOS</div>
                </div>

                <div class="box-image-success">
                  <!-- <img
                    v-if="registerData && registerData.isSuccess"
                    class="sol-image img1"
                    src="../assets/images/registed/congrat.png"
                    alt="success"
                  /> -->
                  <!-- <a
                    v-if="registerData && registerData.isSuccess"
                    class="file"
                    href="https://static.horganice.in.th/cid-reader/dist/Horganice%20CID%20Reader%20Setup%201.0.0.exe"
                    download
                  >
                    <img
                      class="sol-image img2"
                      src="../assets/images/registed/exe-download.png"
                      alt="success"
                    />
                  </a> -->
                  <!-- <a
                    v-if="registerData && registerData.isSuccess"
                    class="file"
                    target="_blank"
                    href="https://static.horganice.in.th/cid-reader/dist/%e0%b8%84%e0%b8%b9%e0%b9%88%e0%b8%a1%e0%b8%b7%e0%b8%ad%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b9%80%e0%b8%9b%e0%b8%b4%e0%b8%94%e0%b9%83%e0%b8%8a%e0%b9%89%e0%b8%87%e0%b8%b2%e0%b8%99.pdf"
                    download
                  >
                    <img
                      class="sol-image img3"
                      src="../assets/images/registed/pdf-download.png"
                      alt="success"
                    />
                  </a> -->
                  <img
                    v-if="registerData && registerData.isSuccess"
                    class="sol-image img4"
                    src="../assets/images/solution.jpg"
                    alt="success"
                  />
                </div>

                <div class="btn-back registed" @click="toggleModalRegister">ปิดหน้าต่างนี้</div>
              </div>

              <div
                class="box-regis-fail"
                v-if="!isLoadRegister && !registerData.isNew && !registerData.isSuccess"
              >
                <div class="header-registed">{{text.failRegister}}</div>
                <div class="text-registed" v-show="registerData.errorTH">{{registerData.errorTH}}</div>
                <div class="text-registed" v-show="registerData.errorEN">{{registerData.errorEN}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store";
import { mapState } from "vuex";
const text = {
  btnPurchase: "สั่งซื้อสินค้าตอนนี้",
  btnPurchase2: "สั่งซื้อสินค้าเพิ่มเติม",
  btnRegister: "การใช้งานเครื่องอ่านบัตร",
  btnRegister2: "เปิดใช้งานเครื่องอ่านบัตร",
  successRegister: "เปิดใช้งานเครื่องอ่านบัตรสำเร็จ!!",
  failRegister: "เปิดใช้งานเครื่องอ่านบัตรไม่สำเร็จ!!"
};

export default {
  props: ["product"],
  data() {
    return {
      text,
      isDev: false,
      isLoadImage: true,
      isGetConfig: false,
      interested: false,
      inputRegister: "",
      isLoadRegister: false,
      isModalRegister: false,
      isLoadInit: false,
      registerData: {
        isNew: true
      },
      formPurchase: {
        number: 1
      },
      isLoadBalanceStore: false,
      balanceStore: null,
      lastPurchase: null,
      isBuyNow: false,
      indexRegisterApartment: null,
      apartmentId: "",
      allApartment: [],
      selectSubProductId: null,
      selectSubProduct: null,
      isErrorSelectSubProduct: false
    };
  },
  async mounted() {
    this.getBalanceStore();
    if (
      (this.product.id == "rWco618dfj" || this.product.id == "0HJLXKDv8r") &&
      this.user.id
    ) {
      let staff = await this.Parse.Cloud.run("Staff_getByUser", {
        userId: this.user.id
      }).catch(err => {
        console.log(err);
      });
      if (staff) {
        let all = [];
        if (this.owners && this.owners.length > 0)
          this.allApartment = all.concat(this.owners, staff);
        else this.allApartment = all.concat(staff);
      }
    } else {
      this.allApartment = this.owners;
    }
  },
  methods: {
    loaded() {
      if (true) {
        this.isLoadImage = false;
        this.$mount();
      }
    },
    async requestQuotation() {
      if (
        this.product &&
        this.product.get("subProducts") &&
        !this.selectSubProductId
      ) {
        this.isErrorSelectSubProduct = true;
      } else {
        this.isErrorSelectSubProduct = false;
        if (!this.user) {
          $("#modalLogin").modal("show");
          store.commit("setPurchasingType", "single");
        } else {
          if (this.user)
            this.$mixpanel.track(`click-purchase-stap1`, {
              products: [this.product.id],
              id: this.user.id,
              tel: this.user.get("tel"),
              name: this.user.get("userProfile").get("firstName"),
              apartmentId: this.$route.query.apartmentId,
              from: "default"
            });
          else
            this.$mixpanel.track(`click-purchase-stap1`, {
              products: [this.product.id],
              from: "default"
            });
          let product;

          if (this.product.get("subProducts")) {
            product = this.product
              .get("subProducts")
              .find(d => d.id == this.selectSubProductId);
          } else {
            product = this.product;
          }

          this.purchaseProduct = {
            id: product.id,
            name: product.get("name"),
            image: product.get("images") ? product.get("images")[0].url() : "",
            number: this.formPurchase.number,
            fullPrice: product.get("fullPrice"),
            price: product.get("price"),
            isIncludeVat: product.get("isIncludeVat"),
            balanceProduct: this.balanceStore.balanceProduct,
            delivery: product.get("delivery") || 0,
            deliveryPerNumber: product.get("deliveryPerNumber") || 0,
            deliveryCategory: product.get("deliveryCategory"),
            productList: product.get("productList") || [],
            discount: product.get("discount") || {}
          };

          store.commit("setFromBuyNow", true);
          $("#main-cid-detail").addClass("modal-open");
          $("#modal-purchase").removeClass("modal-purchase-hide");
          $("body").css({ "overflow-y": "hidden" });

          $("#cart-bar").addClass("hide-cart");
          $("#cart-bar").removeClass("show-cart");

          store.commit("setPurchasingProduct", [this.purchaseProduct]);
          localStorage.setItem(
            "purchase",
            JSON.stringify([this.purchaseProduct])
          );

          if (!this.interested)
            await this.Parse.Cloud.run("MarketProduct_counterInterest", {
              productId: this.$route.params.productId
            }).catch(err => {
              console.log(err);
            });
          this.interested = true;
        }
      }
    },
    async addToCart() {
      if (
        this.product &&
        this.product.get("subProducts") &&
        !this.selectSubProductId
      ) {
        this.isErrorSelectSubProduct = true;
      } else {
        this.isErrorSelectSubProduct = false;
        if (this.user)
          this.$mixpanel.track(`click-add-cart`, {
            product: this.product.id,
            id: this.user.id,
            tel: this.user.get("tel"),
            name: this.user.get("userProfile").get("firstName"),
            apartmentId: this.$route.query.apartmentId
          });
        else
          this.$mixpanel.track(`click-add-cart`, { product: this.product.id });

        this.$gtag.event("cart_product", {
          product_id: this.product.id,
          product_name: this.product.get("name"),
          product_category: this.product.get("categories")[0],
        });
        
        let objCart = {
          productId:
            this.product.get("subProducts") && this.selectSubProductId
              ? this.selectSubProductId
              : this.product.id,
          number: this.formPurchase.number
        };

        if (localStorage.getItem("carts")) {
          if (
            JSON.parse(localStorage.getItem("carts")).findIndex(
              item => item.productId === this.product.id
            ) <= -1
          ) {
            let carts = JSON.parse(localStorage.getItem("carts"));
            let balanceStore = await this.Parse.Cloud.run(
              "MarketProduct_countBalanceStore",
              { productId: this.product.id }
            );

            carts.push(objCart);

            localStorage.setItem("carts", JSON.stringify(carts));
            store.commit("setCarts", carts);
            store.commit("addHashBalanceProduct", balanceStore);
          } else {
            let carts = JSON.parse(localStorage.getItem("carts"));
            for (let cart of carts) {
              if (cart.productId == this.product.id) {
                cart.number = this.formPurchase.number;
              }
            }
            localStorage.setItem("carts", JSON.stringify(carts));
            store.commit("setCarts", carts);
          }
        } else {
          localStorage.setItem("carts", JSON.stringify([objCart]));
          store.commit("setCarts", [objCart]);
        }

        // $("#myToast").toast({ delay: 3000 });
        $("#addCartToast").addClass("show");
        $("#addCartToast").removeClass("hide");

        setTimeout(function() {
          $("#addCartToast").removeClass("show");
          $("#addCartToast").addClass("hide");
        }, 2000);

        this.formPurchase.number = 1;
      }
    },
    clickRegister() {
      this.toggleModalRegister();
    },
    toggleModalRegister() {
      if (this.isModalRegister) {
        this.isModalRegister = false;
      } else {
        this.isModalRegister = true;
      }
    },
    initStyle() {},
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      // console.log(charCode);
      if (
        (charCode >= 48 && charCode <= 57) ||
        (charCode >= 97 && charCode <= 112) ||
        (charCode >= 65 && charCode <= 90)
      ) {
        if (this.inputRegister.length < 13) {
          return true;
        } else {
          evt.preventDefault();
        }
      } else {
        evt.preventDefault();
      }
    },
    isNumberPurchase: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      let key = evt.key;
      let sum = new Number(this.formPurchase.number.toString() + key);
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57 || charCode == 190)
        // && charCode !== 46 //dot
        // && charCode !== 32 //space bar
      ) {
        evt.preventDefault();
      } else {
        if (
          sum > -1 &&
          sum < 10 &&
          this.balanceStore &&
          sum <= this.balanceStore.balanceProduct
        ) {
          return true;
        } else {
          evt.preventDefault();
        }
      }
    },
    numberPluse(data) {
      if (data == "+") {
        let number = new Number(this.formPurchase.number) + 1;
        if (
          number > -1 &&
          this.balanceStore &&
          number <= this.balanceStore.balanceProduct
        ) {
          this.formPurchase.number = number;
        }
      } else if (data == "-") {
        let number = new Number(this.formPurchase.number) - 1;
        if (
          number > 0 &&
          this.balanceStore &&
          number <= this.balanceStore.balanceProduct
        ) {
          this.formPurchase.number = number;
        }
      }
    },
    dateFormat(date, dateFormat) {
      if (date) {
        return this.$moment(date).format(dateFormat);
      } else {
        return "";
      }
    },
    async checkRegister() {
      this.registerData.isNew = true;
      this.registerData.isSuccess = true;
      this.registerData.errorTH = ``;
      this.registerData.errorEN = ``;
      if (this.inputRegister.length < 13) {
        this.registerData.isNew = false;
        this.registerData.isSuccess = false;
        this.registerData.errorTH = `กรุณาใส่หมายเลขซีเรียลให้ครบ 13 หลัก`;
        this.registerData.errorEN = `Please enter the complete 13-digit serial number.`;
      } else if (
        this.registerData &&
        this.registerData.srError == this.inputRegister
      ) {
        this.registerData.isNew = false;
        this.registerData.isSuccess = false;
        this.registerData.errorTH = `ไม่มีหมายเลขซีเรียลนี้ (${this.inputRegister})`;
        this.registerData.errorEN = `Does not have this serial number (${this.inputRegister}).`;
      } else if (!this.apartmentId) {
        this.registerData.isNew = false;
        this.registerData.isSuccess = false;
        this.registerData.errorTH = `กรุณาเลือกหอพักที่ต้องการลงทะเบียน`;
        this.registerData.errorEN = `Please choose the apartment you want to register.`;
      } else {
        try {
          this.registerData.isNew = false;
          this.registerData.isSuccess = false;
          this.registerData.errorTH = null;
          this.registerData.errorEN = null;
          this.registerData.data = null;

          if (!this.interested) {
            let temp;
            this.interested = true;
            this.isLoadRegister = true;
            temp = await this.Parse.Cloud.run(
              "MarketProduct_checkRegisterCidReader",
              {
                serialNumber: this.inputRegister,
                apartmentId: this.apartmentId,
                userId: this.user.id
              }
            );
            this.interested = false;
            // console.log(temp);
            if (temp && temp.isSuccess) {
              this.registerData = {
                isNew: false,
                isSuccess: temp.isSuccess,
                error: temp.error,
                data: temp.data,
                srError: temp.srError
              };
            } else {
              // $("#input-register").addClass("input-repeat-error");
              // $("#btn-register").addClass("btn-repeat-error");
              this.registerData = {
                isNew: false,
                isSuccess: false,
                errorEN: temp.errorEN ? temp.errorEN : "not data respond",
                errorTH: temp.errorTH ? temp.errorTH : "not data respond",
                data: null,
                srError: temp.srError
              };
            }
            this.isLoadRegister = false;
          }
        } catch (err) {
          this.registerData = {
            isNew: false,
            isSuccess: false,
            error: err,
            data: null,
            srError: temp.srError
          };
          this.isLoadRegister = false;
          console.log(err);
        }
      }
    },
    async getBalanceStore(_product) {
      try {
        let product = _product || this.product;
        this.isLoadBalanceStore = true;

        if (!this.hashBalanceProduct[product.id]) {
          this.balanceStore = await this.Parse.Cloud.run(
            "MarketProduct_countBalanceStore",
            { productId: product.id }
          );
          store.commit("addHashBalanceProduct", this.balanceStore);
        } else {
          this.balanceStore = this.hashBalanceProduct[product.id];
        }

        this.isLoadBalanceStore = false;
      } catch (error) {
        console.log(error);
      }
    },
    eArabic(x, num = 0) {
      if (x)
        return x.toLocaleString(undefined, {
          minimumFractionDigits: num,
          maximumFractionDigits: num
        });
      else return num == 2 ? "0.00" : "0";
    },
    changeRegisterApartmnet(index, owner) {
      this.indexRegisterApartment = index;
      this.apartmentId = owner.get("apartment").id;
    },
    changeSubProduct(subProduct) {
      this.selectSubProductId = subProduct.id;
      this.selectSubProduct = this.product
        .get("subProducts")
        .find(d => d.id == this.selectSubProductId);
      this.isErrorSelectSubProduct = false;
      this.formPurchase.number = 1;
      this.getBalanceStore(subProduct);
    }
  },
  computed: {
    imageUrl() {
      if (this.product.get("productCode") == "CID") {
        if (this.product.id == "rWco618dfj") {
          return require("../assets/images/banner/card-reader-gen2.jpg");
        } else {
          return require("../assets/images/banner/card-reader-bn2.jpg");
        }
      } else if (this.product.get("productCode") == "FRT") {
        return require("../assets/images/banner/frt.png");
      } else {
        return "";
      }
    },
    getImage() {
      if (this.banks && this.banks[0] && this.banks[0].no)
        return require(`../assets/banks/${this.banks[0].no}.jpg`);
      else return null;
    },
    ...mapState(["user", "apartment", "hashBalanceProduct", "owners"])
  },
  created() {
    this.initStyle();
  },
  watch: {
    isModalRegister(isTrue) {
      if (isTrue) {
        $("body").css({ "overflow-y": "hidden" });
        $("#main-cid-detail").addClass("modal-open");
        $("#modal-register").removeClass("modal-register-hide");
      } else {
        $("body").css({ "overflow-y": "scroll" });
        $("#main-cid-detail").removeClass("modal-open");
        $("#modal-register").addClass("modal-register-hide");
      }
    }
  }
};
</script>
<style scoped lang="scss">
.container {
  max-width: 1300px;
}
.price {
  color: #e9773b;
  font-weight: bold;
  padding-left: 10px;
  margin-top: 10px;
}
.discription {
  margin-top: 40px;
  color: rgb(70, 70, 70);
}
.nav-tabs .nav-link {
  color: rgb(104, 104, 104);
}
.nav-tabs .active {
  color: #e9773b;
}
.tab-content {
  padding: 20px 10px 20px 30px;
  min-height: 200px;
}
.selecta-apartment-topic {
  font-weight: bold;
  padding-left: 20px;
  margin-top: 20px;
  color: #e9773b;
  margin-bottom: 20px;
}
.address-selector {
  .box-border {
    margin-bottom: 10px;
    cursor: pointer;
    padding: 15px;
  }

  .active {
    border: 3px solid #e9773b;
    padding: 13px;
  }

  p {
    margin: 0;
    padding: 0;
    color: rgb(80, 80, 80);
  }

  .topic-address {
    font-size: 20px;
    font-weight: bold;
  }

  .detail-address {
    font-size: 14px;
  }

  .circle-out {
    display: block;
    width: 25px;
    min-height: 25px;
    background-color: white;
    border: 3px solid #e9773b;
    border-radius: 50%;
    position: relative;
    margin-top: 2px;
    margin-bottom: 7px;
    margin: 12px 5px;
  }

  .circle-in {
    position: absolute;
    left: 2px;
    top: 2px;
    width: 15px;
    height: 15px;
    background-color: #e9773b;
    border-radius: 50%;
  }
}
.select-sub-product {
  border: 1px solid rgb(172, 172, 172);
  padding: 5px 15px;
  cursor: pointer;
  margin: 5px 5px;
  display: inline-block;
}
.select-sub-product.active {
  border: 3px solid #e9773b;
}
@media only screen and (max-width: 768px) {
  .discription {
    padding: 10px;
  }
  .w100-mobile {
    width: 100% !important;
  }
}
@media only screen and (max-width: 540px) {
  .discription {
    padding: 0px;
  }
}
</style>
